import { createCookieStorage } from '@olxeu-eprivacy-storage/js';

export const USER_ID_COOKIE = '__user_id_P&S';
const IS_COOKIE_CONSENT_REQUIRED = false;
const cookieStorage = createCookieStorage(IS_COOKIE_CONSENT_REQUIRED);

export const getCookie = (name: string): string | null => {
  const cookieValue = cookieStorage.get(name);
  if (cookieValue) {
    return decodeURIComponent(cookieValue);
  }

  return null;
};

export default { getCookie, USER_ID_COOKIE };
